
import { Facet } from '../../models/Facet';
import { IOperationActionCreator, implementOperation } from '../../store/actions/implementOperation';
import { ConflictResolution } from '../../facets/ProgressFacets';

export const resolveProgressItemsOperation: Facet<{
  conflictResolution?: ConflictResolution;
}> = new Facet('resolveProgressItemsOperation');

export const resolveProgressItems: IOperationActionCreator<typeof resolveProgressItemsOperation.type> = implementOperation({
  operationTypeFacet: resolveProgressItemsOperation
});
